<!--
 * @Author: your name
 * @Date: 2020-09-15 09:03:23
 * @LastEditTime: 2020-09-16 15:35:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \jiachi-wap\src\components\about\cooperative.vue
-->
<template>
  <div class="cooperative">
    <p class="child-title">合作伙伴</p>
    <p class="child-sub-title">COOPERATIVE PARTNER</p>
    <div class="swiper-box">
      <swiper :options="options" v-if="list.length>0">
        <swiper-slide v-for="(item,index) in list" :key="index">
          <div class="swiper-image-box">
            <img :src="item.image" alt class="swiper-image" />
          </div>
        </swiper-slide>
        <div class="dot" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { hzhb } from "../../assets/js/api";
export default {
  data() {
    return {
      list: [],
      options: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        slidesPerColumn: 2,
        // loop:true,
        autoplay: {
          delay: 3000,
        },
        pagination: {
          el: ".dot",
        },
      },
    };
  },
  created() {
    hzhb({
      limit: 9999,
    }).then((r) => {
      this.list = r.data.data;
    });
  },
};
</script>

<style lang="less" scoped>
.cooperative {
  margin-top: 0.46rem;
  padding-top: 0.73rem;
  background: white;

  .child-title {
    color: #126fcc;
  }

  .swiper-box {
    padding: 0 0.3rem;
  }

  .swiper-image-box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.36rem;
  }

  .swiper-image {
    width: 80%;
    max-height: 100%;
    object-fit: cover;
  }

  .dot {
    text-align: center;
  }
}

/deep/.swiper-pagination-bullet {
  border-radius: 0;
}
</style>
